<!-- Activities -->
<template>
  <div class="mentee-activities">
    <div class="mentee-activities-items">
      <h1>Appointment</h1>
      <ul v-if="appointmentsList.length && appointmentsCount">
        <li class="mentee-activities-list"
            v-for="(item,index) in appointmentsList"
            :key="index">
            <div v-if="item.backLogs.length">
          <zlr-card-service :title=" item.module| filterMdule"
                            style="width: 400px;"
                            :kind="item.module | todaMap"
                            kind-color="#FFADD2"
                            :explain="item.backLogs[0].content"
                            :circle="['TO_BE_COMPLETE_MENTOR','TO_FEEDBACK'].includes(item.statu)? 'waiting':''"
                            @click="handleLinkAppointments(item)">
            <div v-if="item.mentorResultTimeStr">{{item.mentorResultTimeStr}} {{item.mentorZone|zoneTitleMap}}</div>
          </zlr-card-service>
        </div>
        </li>
      </ul>
      <zlr-empty v-else></zlr-empty>
    </div>
    <div class="mentee-activities-items">
      <h1>Program</h1>
      <ul v-if="projectsList.length">
        <li class="mentee-activities-list"
            v-for="(item, index) in projectsList"
            :key="index">
          <zlr-card-service :title="item.project.univer"
                            style="width: 400px;"
                            kind="ETH"
                            :bgText="item.project.univer.replace(/\s/g,'').substr(0,3).toUpperCase()"
                            kind-color="#FFADD2"
                            :explain="item.backLogs[0].content"
                            :dotted=true
                            @click="handleLinkPrograms(item)"
                            :dottedList="item.progress.bills | dottedProgramsfilter">
            <div>{{item.project.overseasName}}</div>
            <div>Application DDL: {{item.project.deadlineTime}}</div>
          </zlr-card-service>
        </li>
      </ul>
      <zlr-empty v-else></zlr-empty>
    </div>
    <div class="mentee-activities-items">
      <h1>CV / RL </h1>
      <ul v-if="cvsList.length || rlsList.length">
        <li class="mentee-activities-list"
            v-for="(item, index) in cvsList"
            :key="`cv${index}`">
          <zlr-card-service title="Curriculum Vitae"
                            style="width: 400px;"
                            kind="CV"
                            :explain="item.backLogs[0].content"
                            :dotted=true
                            :dottedList="item.emEdit | dottedCVRLfilter"
                            @click="handleLinkCVRL(item,'CV')">
            <div>{{item.title}}</div>
          </zlr-card-service>
        </li>
        <li class="mentee-activities-list"
            v-for="(item, index) in rlsList"
            :key="`rl${index}`">
          <zlr-card-service title="Reference Letter"
                            style="width: 400px;"
                            kind="CV"
                            bgText="RL"
                            :explain="item.backLogs[0].content"
                            :dottedList="item.emEdit | dottedCVRLfilter"
                            @click="handleLinkCVRL(item,'RL')">
            <div>{{item.title}}</div>
          </zlr-card-service>
        </li>
      </ul>
      <zlr-empty v-else></zlr-empty>
    </div>
  </div>
</template>
<script>
// api
import { getBacklogList } from '@/api/backlog'
import { getMenteeDetail } from '@/api/mentee'
// components
import ZlrCardService from '_c/card-service/card-service'
import ZlrEmpty from '_c/empty/empty'
// constant
import { moduleMap } from '@/constant'

let thats = this
export default {
  name: 'mentee-activities',
  components: {
    ZlrCardService,
    ZlrEmpty
  },
  data () {
    return {
      menteeNum: this.$route.params.id,
      appointmentsList: [],
      projectsList: [],
      cvsList: [],
      rlsList: [],
      packageId: '',
      appointmentsCount: 0
    }
  },
  computed: {},
  beforeCreate () {
    thats = this
  },
  created () {
    // 获取信息
    this.getMenteeDetail()
  },
  mounted () {
    this.getBacklogList()
  },
  methods: {
    getMenteeDetail () {
      let param = {
        num: this.$route.params.id
      }
      getMenteeDetail(param).then(res => {
        if (res.code === 0) {
          if (res.data.model) {
            this.packageId = res.data.model.packageId
          }
        }
      }).catch(error => {
        this.$zlr_message(error.message, 'error')
      })
    },
    getBacklogList () {
      getBacklogList({
        num: this.menteeNum
      }).then(res => {
        this.appointmentsCount = 0
        this.appointmentsList = res.data.appointments.map(res => { 
          if (res.backLogs.length)
          { 
            this.appointmentsCount++
          }
          return res
        })
        this.projectsList = res.data.projects
        this.cvsList = res.data.cvs.bills.filter(item => item.backLogs[0])
        this.rlsList = res.data.rls.bills.filter(item => item.backLogs[0])
      })
    },
    // Appointment跳转页面
    handleLinkAppointments (item) {
      this.$router.push({
        name: 'mentee-zoom',
        query: {
          id: item.id
        }
      })
    },
    // Prgrams 跳转页面
    handleLinkPrograms (item) {
      let programId = item.project.id
      this.$router.push({
        name: 'mentee-program-essay-info',
        params: {
          programId: programId
        }
      })
    },
    // CV-RL跳转页面
    handleLinkCVRL ({ id }, type) {
      let name = type === 'CV' ? 'mentee-cvrl-cv-detail' : 'mentee-cvrl-rl-detail'
      this.$router.push({
        name,
        query: {
          billId: id
        }
      })
    }
  },
  filters: {
    // 模块对应的 显示文字
    filterMdule (value) {
      if (((thats.packageId === 120) || (thats.packageId === 121)) && value === 'MODULE_1') {
        return 'PS Brainstorming'
      } else {
        return (moduleMap.filter(item => item.value === value))[0]['title']
      }
    },
    // programs生成点
    dottedProgramsfilter (dotted) {
      if (dotted.length === 0) return []
      let arr = []
      dotted.forEach(item => {
        let emEdit = item.emEdit || []
        let smEdit = item.smEdit || []
        let emEditActvie = emEdit.filter(item => item.status === 'EDITED').length
        let smEditActvie = smEdit.filter(item => item.status === 'EDITED').length
        arr.push({
          conNum: emEdit.length + smEdit.length,
          activeNum: emEditActvie + smEditActvie
        })
      })
      return arr
    },
    // CV-RL生成点
    dottedCVRLfilter (emEdit) {
      if (emEdit.length === 0) return []
      let arr = []
      let smEditActvie = emEdit.filter(item => item.status === 'EDITED').length
      arr.push({
        conNum: emEdit.length,
        activeNum: smEditActvie
      })
      return arr
    }
  },
  beforeRouteUpdate (to, from, next) {
    this.menteeNum = this.$route.params.id
    this.getBacklogList()
    next()
  }
}
</script>
<style lang='less' scoped>
</style>
